import {
  HeartCrackIcon,
  HeartHandshakeIcon,
  PhoneIcon,
  UserSearchIcon,
} from "lucide-react";

import { SourcingFunnelCard } from "./SourcingFunnelCard";
import { Column, Row, Text } from "@/components";
import { SourcingFunnelCounts } from "@/types";

// Fixed Found -> Contacted -> Interested -> Not Interested order. Captions vary per section.
const FUNNEL_STAGES = [
  { key: "found", label: "Found", Icon: UserSearchIcon },
  { key: "contacted", label: "Contacted", Icon: PhoneIcon },
  { key: "interested", label: "Interested", Icon: HeartHandshakeIcon },
  { key: "notInterested", label: "Not Interested", Icon: HeartCrackIcon },
] as const;

export const SourcingFunnelCards = ({
  captions,
  counts,
  textLabel,
}: {
  captions: Record<keyof SourcingFunnelCounts, string>;
  counts: SourcingFunnelCounts;
  textLabel?: string;
}) => {
  return (
    <Column className="gap-2">
      {textLabel && <Text variant="muted">{textLabel}</Text>}
      <Row className="min-w-0 gap-4">
        {FUNNEL_STAGES.map((stage) => (
          <SourcingFunnelCard
            key={stage.key}
            caption={captions[stage.key]}
            Icon={stage.Icon}
            label={stage.label}
            value={counts[stage.key]}
          />
        ))}
      </Row>
    </Column>
  );
};
